import { Pipe, PipeTransform } from '@angular/core';

import { statusPretendidos } from '../cliente-analise-mercado-status-pretendido';

@Pipe({
    name: 'clienteAnaliseMercadoStatusPretendido'
})
export class ClienteAnaliseMercadoStatusPretendidoPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = statusPretendidos.findIndex(status => status.id === value);
        if (index > -1) {
            return statusPretendidos[index].nome;
        }
        return '';
    }
}
